import { fromJS } from 'immutable';

import { combineReducerArray } from '../utils/helpers';

import {
  declineFundingMatch,
  OPEN_DECLINE_FUNDING_MATCH_MODAL,
  CLOSE_DECLINE_FUNDING_MATCH_MODAL,
} from './types';

import updateMatchStatusModalReducerObject from './updateMatchStatusModal/reducer';

export * from './actions';

const initialState = fromJS({
  declineFundingMatch: {
    modalOpen: false,
  },
  updateMatchStatusModal: {
    documents: {
      error: false,
      files: [],
      loading: false,
      progress: 0,
    },
    isOpen: false,
    status: null,
    fundingSearchId: null,
    fundingMatchId: null,
    network: {
      loading: false,
      error: false,
      success: false,
    },
  },
});

const fundingMatchReducer = {
  [declineFundingMatch.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .deleteIn(['active', 'byId', action.fundingMatchId])
        .deleteIn(['new', 'byId', action.fundingMatchId])
        .deleteIn(['requireAction', 'byId', action.fundingMatchId])
        .deleteIn(['success', 'byId', action.fundingMatchId]),
    ),

  [OPEN_DECLINE_FUNDING_MATCH_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['declineFundingMatch', 'modalOpen'], true)
        .setIn(['declineFundingMatch', 'activity'], action.activity),
    ),
  [CLOSE_DECLINE_FUNDING_MATCH_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['declineFundingMatch', 'modalOpen'], false)
        .setIn(['declineFundingMatch', 'activity'], false),
    ),
};

export default combineReducerArray(initialState, [
  fundingMatchReducer,
  updateMatchStatusModalReducerObject,
]);
